import { fromJS } from "immutable";

import { canvasDetailsActions } from "actions/canvasDetailsActions.js";

const initialState = fromJS({
    isLoading: true,
    hasErrors: false,
    data: {
        buyplan_id: null,
        canvas_state: null
    }
});

export default (state = initialState, action) => {
    switch (action.type) {
        case canvasDetailsActions.startLoader:
            return state.set("isLoading", true);
        case canvasDetailsActions.reset:
            return initialState;
        case canvasDetailsActions.success:
            return state.merge({
                isLoading: false,
                hasErrors: false,
                data: fromJS(action.payload.data)
            });
        case canvasDetailsActions.failure:
            return state.merge({
                isLoading: false,
                hasErrors: true,
                data: fromJS(action.payload.data)
            });
        default:
            return state;
    }
};
